import {Link} from '@tanstack/react-router';
import {useEffect,useRef,useState} from 'react';
import type {NavigationLink} from '../model';

export function Command({links}:{links:NavigationLink[]}){
  const [open,setOpen]=useState(false),[query,setQuery]=useState('');
  const trigger=useRef<HTMLButtonElement>(null),dialog=useRef<HTMLDialogElement>(null),input=useRef<HTMLInputElement>(null);
  useEffect(()=>{
    const listener=(event:KeyboardEvent)=>{
      if((event.metaKey||event.ctrlKey)&&event.key.toLowerCase()==='k'){event.preventDefault();setOpen(value=>!value);}
    };
    addEventListener('keydown',listener);return()=>removeEventListener('keydown',listener);
  },[]);
  useEffect(()=>{
    const element=dialog.current;
    if(!element)return;
    if(open&&!element.open){element.showModal();requestAnimationFrame(()=>input.current?.focus());}
    if(!open&&element.open)element.close();
  },[open]);
  const visible=links.filter(link=>link.label.toLowerCase().includes(query.toLowerCase()));
  const close=()=>setOpen(false);
  return <>
    <button ref={trigger} className="tu-command-trigger" type="button" aria-haspopup="dialog" aria-expanded={open} aria-controls="tallyup-command-dialog" onClick={()=>setOpen(true)}><span>Go to…</span><kbd>⌘ K</kbd></button>
    <dialog ref={dialog} className="tu-command" id="tallyup-command-dialog" aria-labelledby="tallyup-command-title" onCancel={event=>{event.preventDefault();close();}} onClose={()=>{setOpen(false);setQuery('');trigger.current?.focus();}} onMouseDown={event=>{if(event.target===event.currentTarget)close();}}>
      <div className="tu-command__surface">
        <header><div><span>Navigation</span><h2 id="tallyup-command-title">Go to a workspace view</h2></div><button className="tu-command__close" type="button" aria-label="Close navigation dialog" onClick={close}>×</button></header>
        <label className="tu-command__filter" htmlFor="tallyup-command-filter">Filter destinations</label>
        <input id="tallyup-command-filter" ref={input} value={query} onChange={event=>setQuery(event.target.value)} placeholder="Find a destination" autoComplete="off" />
        <nav aria-label="Matching destinations">{visible.map(link=><Link key={link.routeIdentity} to={link.href} onClick={close}>{link.label}<span aria-hidden="true">↗</span></Link>)}</nav>
        {visible.length===0?<p className="tu-command__empty" role="status" aria-live="polite">No destinations match “{query}”.</p>:null}
      </div>
    </dialog>
  </>;
}
